/*
  pdp.js: behaviour for pdp-* sections.

  Buy box (sections/pdp-buy-box.liquid):
  - Pack and add-on choice. Every money string is rendered by Liquid into the
    section's JSON, so this file never formats money; it only swaps strings.
  - Add to cart goes through Impulse: the form is handed to theme.AjaxProduct,
    which posts to /cart/add.js and fires ajaxProduct:added. Impulse's
    CartDrawer rebuilds and opens on that event, and Shopify's own analytics
    see the /cart/add.js request, so tracking fires as on any product page.
  - Gallery, zoom dialog and the phone sticky bar.
*/
(function () {
  'use strict';

  // Every pdp-* section loads this file; run it once.
  if (window.pdpScriptLoaded) return;
  window.pdpScriptLoaded = true;

  /*
    Hands a product form to Impulse's cart path. theme.AjaxProduct posts the
    form to /cart/add.js, shows errors in the form and fires ajaxProduct:added,
    which makes Impulse's CartDrawer rebuild and open.
  */
  var lastSelection = null;

  /* Closing section: selection line and price follow the buy box. */
  function fillClosing(scope) {
    if (!lastSelection) return;
    var v = lastSelection.variant;
    (scope || document).querySelectorAll('[data-pdp-closing="selection"]').forEach(function (el) {
      var text = v.boxesLabel;
      if (v.capsules && v.days) {
        text = (el.dataset.template || '')
          .replace('[boxes]', v.boxesLabel)
          .replace('[capsules]', v.capsules)
          .replace('[days]', v.days);
      }
      el.textContent = text;
    });
    (scope || document).querySelectorAll('[data-pdp-closing="price"]').forEach(function (el) {
      el.textContent = v.available ? lastSelection.total : '';
    });
    (scope || document).querySelectorAll('[data-pdp-closing="price-wrap"]').forEach(function (el) {
      el.hidden = !v.available;
    });
  }
  document.addEventListener('pdp:selection', function () { fillClosing(document); });

  function bindCartForm(form, button) {
    if (form.dataset.pdpCartBound) return;
    form.dataset.pdpCartBound = 'true';

    if (window.theme && typeof theme.AjaxProduct === 'function') {
      new theme.AjaxProduct(form, '[data-pdp-add]');
      return;
    }

    // Fallback if a theme update ever removes theme.AjaxProduct: same request,
    // same event, so the drawer still opens.
    form.addEventListener('submit', function (evt) {
      evt.preventDefault();
      button.classList.add('btn--loading');
      var cartAdd = (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js';
      fetch(cartAdd, {
        method: 'POST',
        body: new FormData(form),
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }
      })
        .then(function (response) { return response.json(); })
        .then(function (data) {
          button.classList.remove('btn--loading');
          if (data.status && data.status >= 400) {
            showFormError(form, data.description || data.message);
            return;
          }
          if (!document.getElementById('CartDrawer')) {
            window.location.href = (window.theme && theme.routes && theme.routes.cartPage) || '/cart';
            return;
          }
          form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: { product: data, addToCartBtn: button },
            bubbles: true
          }));
        })
        .catch(function () { button.classList.remove('btn--loading'); });
    });
  }

  function showFormError(form, message) {
    var old = form.querySelector('.errors');
    if (old) old.remove();
    if (!message) return;
    var div = document.createElement('div');
    div.className = 'errors';
    div.textContent = typeof message === 'string' ? message : String(message);
    form.append(div);
  }

  function BuyBox(root) {
    this.root = root;
    this.data = JSON.parse(root.querySelector('[data-pdp-data]').textContent);
    this.form = root.querySelector('form.pdp-form');
    this.variantInput = root.querySelector('[data-pdp-variant-input]');
    this.addButton = root.querySelector('[data-pdp-add]');
    this.addon = root.querySelector('[data-pdp-addon]');
    this.addonInputs = root.querySelectorAll('[data-pdp-addon-input]');
    this.sticky = root.querySelector('[data-pdp-sticky]');
    this.dialog = root.querySelector('[data-pdp-zoom-dialog]');
    this.slides = root.querySelectorAll('[data-pdp-slide]');
    this.thumbs = root.querySelectorAll('[data-pdp-thumb]');
    this.currentSlide = 0;

    this.variants = {};
    this.data.variants.forEach(function (v) { this.variants[v.id] = v; }, this);
    this.current = this.variants[Number(this.variantInput.value)];

    this.initCart();
    this.initSelection();
    this.initGallery();
    this.initSticky();
    this.update(false);
  }

  BuyBox.prototype = {
    /* ---------- Selection ---------- */
    initSelection: function () {
      this.root.querySelectorAll('[data-pdp-pack]').forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (!radio.checked) return;
          this.current = this.variants[Number(radio.value)];
          this.update(true);
        }.bind(this));
      }, this);

      if (this.addon) {
        this.addon.addEventListener('change', this.update.bind(this, false));
      }
    },

    setField: function (name, text) {
      this.root.querySelectorAll('[data-pdp-field="' + name + '"]').forEach(function (el) {
        el.textContent = text || '';
      });
    },

    update: function (fromUser) {
      var v = this.current;
      if (!v) return;
      var addonOn = !!(this.addon && this.addon.checked && v.totalAddon);

      this.variantInput.value = v.id;
      this.root.querySelectorAll('[data-pdp-pack]').forEach(function (radio) {
        radio.checked = Number(radio.value) === v.id;
      });
      this.addonInputs.forEach(function (input) { input.disabled = !addonOn; });

      this.setField('price', v.price);
      this.setField('compare', v.compare);
      this.setField('saving', v.saving);
      this.root.querySelectorAll('[data-pdp-field="compare"], [data-pdp-saving-row]').forEach(function (el) {
        el.hidden = !v.saving;
      });
      this.setField('summary', v.summary);
      this.setField('per-day', v.perDay);
      this.setField('total', addonOn ? v.totalAddon : v.total);
      this.setField('sticky', v.sticky + (addonOn ? this.data.addonSuffix : ''));
      this.setField('add-label', v.available ? this.data.addLabel : this.data.soldOutLabel);
      this.root.querySelectorAll('[data-pdp-field="stock"]').forEach(function (el) { el.hidden = !v.available; });

      if (this.addButton) this.addButton.disabled = !v.available;

      // Let other pdp-* sections (the closing block) follow the selection.
      lastSelection = { variant: v, total: addonOn ? v.totalAddon : v.total };
      document.dispatchEvent(new CustomEvent('pdp:selection', { detail: lastSelection }));
      var stickyAdd = this.root.querySelector('[data-pdp-sticky-add]');
      if (stickyAdd) stickyAdd.disabled = !v.available;

      // Same as Impulse: keep ?variant= in step so the URL can be shared.
      if (fromUser && window.history && history.replaceState && !(window.Shopify && Shopify.designMode)) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({ path: url.toString() }, '', url.toString());
      }
    },

    /* ---------- Cart ---------- */
    initCart: function () {
      if (this.form && this.addButton) bindCartForm(this.form, this.addButton);
    },

    submit: function () {
      if (!this.addButton || this.addButton.disabled) return;
      if (typeof this.form.requestSubmit === 'function') {
        this.form.requestSubmit(this.addButton);
      } else {
        this.addButton.click();
      }
    },

    /* ---------- Gallery and zoom ---------- */
    initGallery: function () {
      this.thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          this.showSlide(Number(thumb.dataset.pdpThumb));
        }.bind(this));
      }, this);

      var zoomCurrent = this.root.querySelector('[data-pdp-zoom-current]');
      if (zoomCurrent) {
        zoomCurrent.addEventListener('click', function () {
          var slide = this.slides[this.currentSlide];
          if (slide) this.openZoom(slide.dataset.zoomSrc, slide.dataset.alt);
        }.bind(this));
      }

      this.root.querySelectorAll('[data-pdp-zoom-src]').forEach(function (button) {
        button.addEventListener('click', function () {
          this.openZoom(button.dataset.pdpZoomSrc, button.dataset.pdpZoomTitle);
        }.bind(this));
      }, this);

      if (!this.dialog) return;
      this.dialog.querySelector('[data-pdp-zoom-close]').addEventListener('click', this.closeZoom.bind(this));
      this.dialog.addEventListener('click', function (evt) {
        if (evt.target === this.dialog) this.closeZoom();
      }.bind(this));
      this.dialog.addEventListener('close', this.syncSticky.bind(this));
    },

    showSlide: function (index) {
      this.currentSlide = index;
      this.slides.forEach(function (slide, i) { slide.hidden = i !== index; });
      this.thumbs.forEach(function (thumb, i) { thumb.setAttribute('aria-pressed', String(i === index)); });
      var caption = this.root.querySelector('[data-pdp-caption]');
      var slide = this.slides[index];
      if (caption && slide) caption.textContent = index === 0 && this.data.caption ? this.data.caption : slide.dataset.alt;
    },

    openZoom: function (src, title) {
      if (!this.dialog || !src) return;
      var img = this.dialog.querySelector('[data-pdp-zoom-img]');
      img.src = src;
      img.alt = title || '';
      this.dialog.querySelector('[data-pdp-zoom-title]').textContent = title || '';
      if (typeof this.dialog.showModal === 'function') {
        this.dialog.showModal();
      } else {
        this.dialog.setAttribute('open', '');
      }
      this.syncSticky();
    },

    closeZoom: function () {
      if (typeof this.dialog.close === 'function') {
        this.dialog.close();
      } else {
        this.dialog.removeAttribute('open');
      }
      this.syncSticky();
    },

    /* ---------- Sticky bar ---------- */
    initSticky: function () {
      if (!this.sticky || !this.addButton) return;
      this.mainButtonVisible = true;

      this.sticky.querySelector('[data-pdp-sticky-add]').addEventListener('click', this.submit.bind(this));

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          this.mainButtonVisible = entries[0].isIntersecting;
          this.syncSticky();
        }.bind(this)).observe(this.addButton);
      }

      // Landing pages can hold the bar back until the visitor has scrolled past
      // the hero buttons (lp-hero marks them with data-pdp-sticky-gate).
      var gate = document.querySelector('[data-pdp-sticky-gate]');
      this.gateBlocking = !!gate;
      if (gate && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var entry = entries[0];
          this.gateBlocking = entry.isIntersecting || entry.boundingClientRect.top > 0;
          this.syncSticky();
        }.bind(this)).observe(gate);
      }

      // Impulse marks <html> with js-drawer-open while its cart drawer is open.
      new MutationObserver(this.syncSticky.bind(this))
        .observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    },

    syncSticky: function () {
      if (!this.sticky) return;
      var drawerOpen = document.documentElement.classList.contains('js-drawer-open');
      var zoomOpen = this.dialog && this.dialog.hasAttribute('open');
      this.sticky.hidden = this.mainButtonVisible || drawerOpen || zoomOpen || !!this.gateBlocking;
    }
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-pdp-buy-box]').forEach(function (root) {
      if (root.dataset.pdpReady) return;
      root.dataset.pdpReady = 'true';
      new BuyBox(root);
    });
    fillClosing(scope);
    // Other add-to-cart forms in pdp-* sections, e.g. the routine set.
    (scope || document).querySelectorAll('form.pdp-ajax-form').forEach(function (form) {
      var button = form.querySelector('[data-pdp-add]');
      if (button) bindCartForm(form, button);
    });
  }

  // A link to an accordion's anchor (e.g. "full ingredient list" -> #vh-ingredients) opens it.
  document.addEventListener('click', function (evt) {
    var link = evt.target.closest && evt.target.closest('.pdp a[href^="#"]');
    if (!link || link.getAttribute('href').length < 2) return;
    var target = document.getElementById(link.getAttribute('href').slice(1));
    if (target && target.tagName === 'DETAILS') target.open = true;
  });

  init(document);
  document.addEventListener('shopify:section:load', function (evt) { init(evt.target); });
})();
